import { ClientProfileUpdateViewModel } from '../../../../common/model/client/clientProfileUpdateViewModel';
import { createSelector } from '@reduxjs/toolkit';
import { StorageState } from '../../../reducers';

export const clientErrorsSliceSelector = (state: StorageState) => state.client.clientErrors;

export const addAccountsAccountErrorSelector = createSelector(
    clientErrorsSliceSelector,
    slice => slice.addAccountsAccountError
);

export const addAccountsAnswerErrorSelector = createSelector(
    clientErrorsSliceSelector,
    slice => slice.addAccountsAnswerError
);

export const smsErrorSelector = createSelector(
    clientErrorsSliceSelector,
    slice => slice.smsError
);

export const registrationEmailErrorSelector = createSelector(
    clientErrorsSliceSelector,
    slice => slice.registrationEmailError
);

export const registrationPhoneErrorSelector = createSelector(
    clientErrorsSliceSelector,
    slice => slice.registrationPhoneError
);

export const registrationAccountErrorSelector = createSelector(
    clientErrorsSliceSelector,
    slice => slice.registrationAccountError
);

export const registrationAnswerErrorSelector = createSelector(
    clientErrorsSliceSelector,
    slice => slice.registrationAnswerError
);
